// extracted by mini-css-extract-plugin
module.exports = {"activityInfo":"styles_activityInfo__2Uvhi","activityCardsWrapper":"styles_activityCardsWrapper__MPPcK"};